import * as React from 'react';
import * as ReactDOM from 'react-dom';
// Rename after merging
import YadoSearchForm from './YadoSearchForm';
import YadoList from './YadoList';
import ItemSearchForm from './ItemSearchForm';
import SnowSearchFormModal from './SnowSearchFormModal';
import { ISearchFormProps, ICurrency } from './types';


document.addEventListener('turbolinks:load', () => {

  const _retrieveProps = (element: Element): ISearchFormProps & { isMobile: boolean } => {
    const yado_candidate_list = JSON.parse(element.getAttribute('data-yado-candidate-list') || '{}');
    const checkin_date = element.getAttribute('data-checkin-date');
    const checkout_date = element.getAttribute('data-checkout-date');
    const rooms = JSON.parse(element.getAttribute('data-rooms') || '[]');
    const q = JSON.parse(element.getAttribute('data-q'));
    const isMobile = element.hasAttribute('data-is-mobile');
    return { yado_candidate_list, checkin_date, checkout_date, rooms, q, isMobile };
  }

  Array.from(document.querySelectorAll('.js-snow-search__yado-search-form')).forEach((element) => {
    const recommended_stay_list = JSON.parse(element.getAttribute('data-recommended-stay-list') || '{}');
    const is_toppage = (element.getAttribute('data-is-toppage') == 'true' ? true : false);
    ReactDOM.render(
      <YadoSearchForm {..._retrieveProps(element)} placement="top" recommended_stay_list={recommended_stay_list} is_toppage={is_toppage} />,
      element as HTMLElement
    );
  });

  Array.from(document.querySelectorAll('.js-snow-search__yado-list')).forEach((element) => {
    const yados = JSON.parse(element.getAttribute('data-yados') || '[]');
    const resorts = JSON.parse(element.getAttribute('data-resorts') || '[]');
    const currency: ICurrency = JSON.parse(element.getAttribute('data-currency'));
    ReactDOM.render(
      <YadoList {..._retrieveProps(element)} yados={yados} resorts={resorts} currency={currency} />,
      element as HTMLElement
    );
  });

  Array.from(document.querySelectorAll('.js-snow-search__search-modal')).forEach((element) => {
    const recommended_stay_list = JSON.parse(element.getAttribute('data-recommended-stay-list') || '{}');
    const snow_item_candidate_list = JSON.parse(element.getAttribute('data-snow-item-candidate-list') || '{}');
    const triggerType = (element.getAttribute('data-trigger-type') || 'icon') as 'yadoField' | 'icon';
    const activePill = element.getAttribute('data-active-pill') || 'yado'
    ReactDOM.render(
      <SnowSearchFormModal
        {..._retrieveProps(element)}
        recommended_stay_list={recommended_stay_list}
        snow_item_candidate_list={snow_item_candidate_list}
        triggerType={triggerType}
        activePill={activePill} />,
      element as HTMLElement
    );
  });

  // トップページ検索機能
  Array.from(document.querySelectorAll('.js-snow-search__item-search-form')).forEach((element) => {
    const q = JSON.parse(element.getAttribute('data-q') || '{}');
    const snow_item_candidate_list = JSON.parse(element.getAttribute('data-snow-item-candidate-list') || '{}');
    const recommended_snow_list = JSON.parse(element.getAttribute('data-recommended-snow-list') || '{}');
    const isMobile = element.hasAttribute('data-is-mobile');
    const is_toppage = (element.getAttribute('data-is-toppage') == 'true' ? true : false);
    ReactDOM.render(
      <ItemSearchForm
        q={q}
        snow_item_candidate_list={snow_item_candidate_list}
        recommended_snow_list={recommended_snow_list}
        isMobile={isMobile}
        is_toppage={is_toppage} />,
      element as HTMLElement
    );
  });

});

// UseEffectの返り値をTurbolinksのページ遷移で実行させるため、明示的にアンマウントしている。
// https://github.com/wamazing/wamazing-snow/pull/4450
const unmountComponentOnLinkClick = [
  '.js-snow-search__yado-search-form',
  '.js-snow-search__item-search-form',
  '.js-snow-search__search-modal',
].join(', ');
document.addEventListener('turbolinks:before-cache', () => {
  Array.from(document.querySelectorAll(unmountComponentOnLinkClick)).forEach((element) => {
    ReactDOM.unmountComponentAtNode(element);
  });
});
